import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Historique Redux States
import {
  GET_HISTORIQUES,
} from "./actionType";

import {
  historiqueApiResponseSuccess,
  historiqueApiResponseError,
} from "./action";

//Include Both Helper File with needed methods
import {
  getHistoriques as getHistoriquesApi,
} from "../../helpers/fakebackend_helper";

function* getHistoriques() {
  try {
    const response = yield call(getHistoriquesApi);
    yield put(historiqueApiResponseSuccess(GET_HISTORIQUES, response));
  } catch (error) {
    yield put(historiqueApiResponseError(GET_HISTORIQUES, error));
  }
}

export function* watchGetHistoriques() {
  yield takeEvery(GET_HISTORIQUES, getHistoriques);
}



function* historiqueSaga() {
  yield all([
    fork(watchGetHistoriques),
  ]);
}

export default historiqueSaga;
